import moment from 'moment-timezone';

const initialState = {
  queuedCalls: []
}
export default function(state = initialState, action){
    switch(action.type){
        case "SET_QUEUED_CALLS":
            return {
              ...state,
              queuedCalls: action.payload.map((call) => {
                return {
                  service_id: call.service_id,
                  service_name: call.service,
                  callerid: call.callerid,
                  linkedid: call.linkedid,
                  agent_name: '',
                  startTime: (moment().unix() - parseInt(call.time))
                }
              })
            };
        case "QUEUE_CALL_JOIN":
          return {
            ...state,
            queuedCalls: [...state.queuedCalls, {
              service_id: action.payload.service.serviceid,
              service_name: action.payload.service.name,
              callerid: action.payload.callerid,
              linkedid: action.payload.linkedid,
              agent_name: action.payload.agent.name,
              startTime: action.payload.time
            }]
          };
        case "QUEUE_CALL_NO_ANSWER":
          return {
            ...state,
            queuedCalls: state.queuedCalls.map(item => (item.linkedid == action.payload.linkedid)
             ? {
               ...item,
               agent_name: ''
             } : item)
          }
        case "QUEUE_CALL_LEAVE":
          return {
            ...state,
            queuedCalls: state.queuedCalls.filter(item => (item.linkedid !== action.payload.linkedid))
          };
        case "QUEUE_CALL_MODIFY":
          return {
            ...state,
            queuedCalls: state.queuedCalls.map(item => (item.linkedid == action.payload.linkedid) ? {
              ...item,
              agent_name: action.payload.agent_name
            } : item)
          };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/queuedCalls.js